<!-- Standard page layout-->
<cu-dynamic-page-workflow-progress class="ww-position--sticky" [page]="page" [flow]="flow"></cu-dynamic-page-workflow-progress>
<cu-dynamic-page-layout [page]="page" [flow]="flow">
  <div page-body>
    <div class="bl-display--flex">
      <header *ngIf="(page.customTitleOrDefault || page.config?.subtitle)"
        class="bl-flex--auto bl-margin-bottom--16 bl-margin-bottom-sm--24">
        <h1 class="bl-font-size--32 bl-font-weight--900 bl-font-color--black bl-margin-bottom--0 bl-text-transform--capitalize bl-display--block">
          {{page.customTitleOrDefault}}
        </h1>
        <p *ngIf="page.config?.subtitle" class="bl-font-color--black"> {{ page.config.subtitle }} 
          <a href="javascript:void(0)" *ngIf="slideoutContent" (click)="openSlideInPanel()">
            {{ 'slideOut/actionlink'| dictionary }}
          </a>
        </p>
      </header>
    </div>
    <cu-dynamic-page-alert [page]="page" [flow]="flow"></cu-dynamic-page-alert>
    <cu-dynamic-page-validation [page]="page" [flow]="flow"></cu-dynamic-page-validation>
    <cu-dynamic-page-cards [page]="page" [flow]="flow"></cu-dynamic-page-cards>
    <cu-dynamic-page-action-bar [page]="page" [flow]="flow"></cu-dynamic-page-action-bar>
    <cu-dynamic-page-modal-popup *ngIf="page.modalVisible" [page]="page" [flow]="flow" ></cu-dynamic-page-modal-popup>
  </div>
</cu-dynamic-page-layout>
<!-- Slide in panel-->
<ea-slide-in-panel *ngIf="slideoutContent" class="third-panel" [(isSlidePanelVisible)]="isOpen" [slidePanelTitle]="slideoutContent.title" [fixedLayout]="true"
  openPanelElementId="">
  <div class="bl-block-module bl-font-color--base bl-text-align--top bl-padding--24 bl-width-md--100">
     <p class=" bl-font-weight--x-bold">{{slideoutContent.header}}</p>
      <p [innerHTML]="slideoutContent.description|safe:'html'"></p>
    </div>
</ea-slide-in-panel>